import React, { Component } from "react";
import axios from "axios";
import PanelHeader from "../../components/PanelHeader/PanelHeader";
import { Card, CardBody, Col, CardHeader, Row } from "reactstrap";
import { FolderOutlined, FileOutlined, MenuOutlined, RightOutlined, AppstoreOutlined, LoadingOutlined } from '@ant-design/icons';
import { yellow600 } from "material-ui/styles/colors";
import { Modal, Tooltip, Spin } from 'antd';
class ftps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            currentItem: null,
            open: false,
            confirmLoading: false,
            selectedItem: {},
            loadingItem: null,
            vistaCuadricula: false,
            // lastItems: []
        };
        this.handleFolderClick = this.handleFolderClick.bind(this);
        this.firstLoadItems = this.firstLoadItems.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.showModal = this.showModal.bind(this);
        this.handleToggleGrid = this.handleToggleGrid.bind(this);
        this.loadRoute = this.loadRoute.bind(this);
    }
    componentDidMount() {
        this.firstLoadItems();

    }

    componentWillUnmount() {

    }

    async handleRouteClick(route) {
        if (this.state.loadingItem === null) {
            try {
                let folder = {
                    route: route,

                    provider: this.state.currentItem.provider,
                    providerId: this.state.currentItem.providerId
                }
                this.handleFolderClick(folder);
            } catch (error) {
                console.error('Error al obtener contenido de la carpeta:', error);
            }
        }
    };
    async handleFolderClick(folder) {

        try {
            this.setState({
                loadingItem: folder,
                currentItem: folder
            });
            const response = await axios.post('https://backoffice.nadu.xyz/api/mobiles/doFTPAction', { provider: folder.provider, providerId: folder.providerId, option: "open", route: folder.route });
            this.setState({ items: response.data })
            this.setState({ loadingItem: null });
        } catch (error) {
            console.error('Error al obtener contenido de la carpeta:', error);
        }
    };
    async firstLoadItems() {
        this.setState({
            loadingItem: "firstLoad",
            currentItem: null
        });
        try {
            const providers = await axios.get('https://backoffice.nadu.xyz/api/mobile-providers');
            let formattedProviders = providers.data.data.map(provider => ({
                name: provider.attributes.name,
                route: "",
                isFolder: true,
                provider: provider.attributes.name,
                providerId: provider.id
            }));
            this.setState({ items: formattedProviders })
            this.setState({ loadingItem: null });
        } catch (error) {
            console.error('Error al obtener contenido:', error);
        }
    };
    loadRoute() {
        let { currentItem } = this.state;
        if (!currentItem) return null;
        if (currentItem.route === "/") currentItem.route = "";
        let routeComponents = currentItem.route.split("/");
        let composedRoute = "";
        // const lastItemOfRouteComponents = routeComponents[routeComponents.length - 1];

        //const lastItemOfLastItems = this.state.lastItems[this.state.lastItems.length - 1];
        // console.log(lastItemOfLastItems);
        /* if (lastItemOfRouteComponents !== lastItemOfLastItems) {
             console.log(lastItemOfRouteComponents);
             console.log(lastItemOfLastItems);
             const updatedLastItems = [...this.state.lastItems, lastItemOfRouteComponents];
             this.setState({ lastItems: updatedLastItems });
         }*/


        let result = routeComponents.map((item) => {
            let itemName = item;
            let currentRoute = itemName;

            if (item.length === 0) {
                itemName = currentItem.provider;
            }

            composedRoute = "/" + currentRoute;
            currentRoute = (' ' + composedRoute).slice(1);
            return (
                <div key={composedRoute}>
                    <RightOutlined style={{ paddingRight: "5px" }} />
                    <button style={{ cursor: "pointer", fontStyle: "italic", border: "0" }} key={currentRoute} onClick={() => this.handleRouteClick(currentRoute)}>
                        {itemName}
                    </button>
                </div>
            );
        });
        return result
    }
    showModal(item) {
        this.setState({ selectedItem: item })
        this.setState({ open: true })
    };
    async handleOk() {
        this.setState({ setConfirmLoading: true })
        try {
            const response = await axios.post('https://backoffice.nadu.xyz/api/mobiles/doFTPAction', { provider: this.state.selectedItem.provider, providerId: this.state.selectedItem.providerId, option: "download", route: this.state.selectedItem.route, file: this.state.selectedItem.name });
            const dataURI = `data:${response.filetype};base64,${response.data.data}`;
            const linkSource = dataURI;
            const downloadLink = document.createElement("a");
            const fileName = response.data.filename;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        } catch (error) {
            console.log(error);
        }
        this.setState({ open: false })
        this.setState({ setConfirmLoading: false })
    };
    handleCancel() {
        this.setState({ selectedItem: {} })
        this.setState({ open: false })
    };
    handleToggleGrid() {
        this.setState({ vistaCuadricula: !this.state.vistaCuadricula })
    };

    render() {
        return (
            <div>
                <Modal
                    title={"¿Estás seguro que deseas descargar " + this.state.selectedItem.name + "?"}
                    open={this.state.open}
                    onOk={this.handleOk}
                    confirmLoading={this.state.confirmLoading}
                    onCancel={this.handleCancel}
                />
                <PanelHeader size="sm" />
                <div className="content">
                    <Row style={{ width: "100%", height: "100%" }}>
                        <Col xs={12} >
                            <Card style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>


                                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", padding: "10px" }} >
                                    <button style={{ cursor: "pointer", fontStyle: "italic", border: "0" }} onClick={() => this.firstLoadItems()}> FTPs</button>
                                    {this.loadRoute()}
                                </div>
                                <div style={{ cursor: "pointer", fontStyle: "italic", border: "0", padding: "10px" }} onClick={() => this.handleToggleGrid()}>
                                    {this.state.vistaCuadricula ? <Tooltip placement="left" title="Modo Lista"><AppstoreOutlined /></Tooltip> : <Tooltip placement="left" title="Modo Grid"><MenuOutlined /></Tooltip>}
                                </div>
                            </Card>
                        </Col>

                        {this.state.items.length > 0 && this.state.loadingItem === null ?

                            this.state.items.map((item, index) => (
                                <Col key={item.name} style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "20px" }} xs={12} md={this.state.vistaCuadricula ? 12 : 4} lg={this.state.vistaCuadricula ? 12 : 3}>
                                    <Card style={{ marginBottom: "5px", }}>
                                        <CardBody
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                userSelect: "none",
                                                gap: "4px",
                                                padding: "15px",
                                                height: "60px"
                                            }}
                                            onDoubleClick={() => item.isFolder ? this.state.loadingItem === null && this.handleFolderClick(item) : this.showModal(item)}
                                        >
                                            {item.isFolder ?
                                                (this.state.loadingItem === item ?
                                                    <p width="100%" height="100%" style={{ fontSize: "1rem" }}>Cargando...</p> :
                                                    <FolderOutlined width="100%" height="100%" style={{ color: yellow600, fontSize: "2rem" }} />
                                                )
                                                : (
                                                    <span style={{ position: 'relative', display: 'inline-block' }}>
                                                        <FileOutlined style={{ position: 'relative', fontSize: "2rem" }} />
                                                        <span style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textTransform: 'uppercase', fontSize: "0.4rem" }}>
                                                            {item.name.split(".").pop()}
                                                        </span>
                                                        <span style={{ position: 'absolute', top: '0', width: "5rem", transform: 'translate(0%, -50%)', fontSize: "0.5rem", fontWeight: "bold" }}>
                                                            {item.size}
                                                        </span>
                                                    </span>
                                                )
                                            }
                                        </CardBody>
                                    </Card>
                                    {item.name}
                                </Col>
                            )) : this.state.loadingItem !== null ?
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', width: "100%" }}>
                                    <Spin
                                        indicator={
                                            <LoadingOutlined
                                                style={{
                                                    fontSize: 24,
                                                }}
                                                spin
                                            />
                                        }
                                    />
                                </div>
                                : "No se ha encontrado ningún archivo."}
                    </Row>
                </div>
            </div>
        );
    }
}

export default ftps;



// WEBPACK FOOTER //
// ./src/views/Configurator/ftps.jsx